module.exports = __webpack_public_path__ + "static/media/icone-sucesso.a64a5f77.svg";